/**
 * initWelcomePopup (jQuery version, SWUP-safe)
 */
function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
}

function getCookie(name) {
  const parts = decodeURIComponent(document.cookie).split(';');
  for (let c of parts) {
	c = c.trim();
	if (c.indexOf(name + '=') === 0) return c.substring(name.length + 1);
  }
  return '';
}

export default function initWelcomePopup() {
  const $ = window.jQuery || window.$;        // ← resolve jQuery safely
  if (!$ || typeof $.fn === 'undefined') {
	console.warn('[welcome] jQuery not found yet; skipping init.');
	return;
  }

  // Avoid stacking handlers
  $(document).off('click.welcomePopup')
			 .on('click.welcomePopup', '.continue', function (e) {
				e.preventDefault();
				$('.welcome').fadeOut();
				setCookie('_gf_welcome', '1', 30);
			 });

  const $welcome = $('.welcome');
  if (!$welcome.length) return;               // no markup on this page

  if (getCookie('_gf_welcome')) {
	$welcome.hide();
	return;
  }

  // Delay show; double-check cookie at show-time
  window.clearTimeout(window.__welcomeTimer);
  window.__welcomeTimer = window.setTimeout(() => {
	if (!getCookie('_gf_welcome')) $welcome.fadeIn();
  }, 2000);
}
